import React, {ReactNode, useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {Outlet} from 'react-router-dom';
import {LoadingOverlay, ThemeName, Theme} from '@taopix/taopix-design-system';
import classNames from 'classnames';
import {useProductsContext} from '../Context/Products/ProductsContext';
import {formatOnlineUrl} from '../../Utils/Common';

const Selector = ({children}: {children?: ReactNode}) => {
  const {state} = useProductsContext();

  const {t} = useTranslation();

  const appClasses = classNames(
    'flex',
    'flex-col',
    'flex-1',
    'max-w-full',
    'max-h-full',
    'min-h-0'
  );

  const logo = useMemo(() => {
    return formatOnlineUrl(state.logo.image);
  }, [state.logo]);

  return (
    <>
      <LoadingOverlay
        id={'app-busy-overlay'}
        open={state.loading}
        label={t('*:str_MessagePleaseWait')}
        delay={500}
        key={'app-busy-overlay'}
        theme={ThemeName.Popouts}
      />
      <div className={appClasses}>
        <Theme
          name={'tpx-theme-header'}
          className="selectCollectionStep-Header flex h-[160px] w-full justify-center"
          allowBorder={false}
          allowCorners={false}
        >
          <div className="selectCollectionStep-HeaderLogoContainer flex items-center justify-start w-[min(1440px,theme(width.bounds))] px-lg">
            {state.loaded && <img src={logo} width="70" alt="Hema logo" />}
          </div>
        </Theme>
        <div className="selectCollectionStep-ContentArea flex-1 w-[min(1440px,theme(width.bounds))] px-lg mx-auto overflow-auto mb-md">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Selector;
